const encoder = new TextEncoder();
const decoder = new TextDecoder();
export function encode(msg) {
    return encoder.encode(JSON.stringify(msg));
}
export function decode(data) {
    return JSON.parse(decoder.decode(data));
}
